var UnrenderableThumb = require('../unrenderableThumb/unrenderableThumb');


/**
 * For now, just adding an indicator that the thumb is a Multipart Gos Page
 */


module.exports = UnrenderableThumb.extend({

    onRender: function() {

        UnrenderableThumb.prototype.onRender.apply(this, arguments);

        this.$('.thumb-unrenderable-text-msg').html(
            this.$('.thumb-unrenderable-text-msg').html() + ':\n' + this.model.getFriendlyName()
        );

    }

});


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/page/thumbnail/multipartGosThumb/view.js
 ** module id = 570
 ** module chunks = 0
 **/